import vetting_modal from './vetting_modal.js'
import pages from './pages.js'
import firebase from './firebase.js'

export default {
  app_name: 'Piola',
  operation_name: 'Piola',
  display_app_name: 'Piola',
  stylesheet: '/office.css',
  favicon: '/office_favicon.png',
  base_api_url: 'https://office.suitupapi.club/',
  // conv-svc / intake operation slug — routes the readonly chatbot panel to this tenant's API
  intake_operation_slug: 'piola',
  preview_link: 'https://office.suitup.website/offer_preview/',
  company_panel_url: 'https://office.companies.suitup.co.il/',
  seo_single_position_path: 'single_office_position',
  field: 'האדמיניסטרציה',
  recruitement_field: 'השמה בעולם האדמיניסטרציה',
  discrete_emoji: '🤩',
  icon: '🟣',
  files: {
    is_profile_default_checked: false
  },
  applicant_modal: {
    languages: ['אנגלית']
  },
  applicant_history_company_modal: {
    job_title_options: []
  },
  vetting_modal,
  pages,
  images: {
    logo_bright: '/piola_logo_light.svg',
    logo_dark: '/piola_logo_dark.svg'
  },
  links: {
    website_url: 'https://www.piola.co.il/',
    web_base_url: 'https://web.piola.co.il/',
    app_store_url: 'https://apps.apple.com/us/app/suitup-office/id1458626807',
    google_play_url: 'https://play.google.com/store/apps/details?id=website.suitup.office'
  },
  hashtags: 'piola\nsuitup',
  firebase,
  full_env_name: 'suitup_office_production'
}
